import { useEffect, useState } from 'react';
import charmhealthlogo_placeholder from '../../../../assets/charmhealthlogo_placeholder.jpg';
import { buttonLabels } from '../../../../Constants/Data'
import { useToast } from "../../../../Common/ToastContext";

const ListingIcon = ({ listing, seteditProductId, setShowEditListing, handleUnpublishClick }) => {
    const showToast = useToast();

    const handleEditClick = (listing) => {
        seteditProductId(listing.id);
        setShowEditListing(true);
    };

    const styles = {
        container: "h-[25rem] w-full bg-white flex flex-col p-3 shadow-md font-proxima-nova",
        imageContainer: "flex-shrink-0 sm:w-40 sm:h-40 w-28 h-28", // Fixed size for the image container
        textContainer: "flex-1 flex flex-col justify-center min-w-0", // Allows the text to grow but not push the image
        listingName: "text-center text-2xl sm:text-3xl md:text-4xl text-gray font-proxima-nova font-bold opacity-80 break-words whitespace-normal max-w-md line-clamp-2",
        ratingContainer: "mt-4 text-3xl sm:text-3xl text-center inline-flex items-center mx-5 gap-0",
        noReviewText: "mt-2 text-sm sm:text-md text-gray-500 italic text-center font-proxima-nova",
        statusPublished: "mx-2 flex flex-row items-center gap-2 sm:gap-4",
        statusNotPublished: "flex flex-row items-center gap-2 sm:gap-4",
        statusIconPublished: "w-6 h-6 bg-[#3dde02] rounded-full border border-white border-[1px] shadow-md",
        statusIconNotPublished: "w-6 h-6 bg-lightNeutral rounded-full border-white border-[1px] shadow-md",
        statusText: "text-[18px] text-[#505050] font-proximanova",
        updateButton: "text-[18px] font-[600] px-3 sm:px-4 py-1 sm:py-2 text-charmOrange rounded-full whitespace-nowrap font-proximanova underline",
        deleteButton: "close-button-hover text-red text-sm sm:text-lg font-semibold px-3 sm:px-4 py-1 sm:py-2 font-proxima-nova",
        flexRow: "flex flex-row justify-between items-center",
    };

    const getCategoryLabel = (categoryNumber) => {
        const category = buttonLabels.find(btn => btn.number === parseInt(categoryNumber));
        return category ? category.label : categoryNumber.toString();
    };

    const getCategoryColor = (categoryNumber) => {
        const category = buttonLabels.find(btn => btn.number === parseInt(categoryNumber));
        return category ? category.background : categoryNumber.toString();
    };


    // THIS IS THE TOGGLE FOR THE DROPDOWN MENU FOR UNPUBLISHING A LISTING
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);


    const StarFilledIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="#ffa400"
                className="bi bi-star"
                viewBox="0 0 20 20"
            >
                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 
                    4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8
                    13.187l-4.389 2.256z" />
            </svg>
        );
    };

    const StarEmptyIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="#ffa400"
                className="bi bi-star"
                viewBox="0 0 20 20"
            >
                <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 
                    4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 
                    3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927
                    0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 
                    3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 
                    0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0
                    .393-.288L8 2.223l1.847 3.658a.53.53 0 0 
                    0 .393.288l4.052.575-2.906 2.77a.56.56 0 0
                    0-.163.506l.694 3.957-3.686-1.894a.5.5 0 
                    0 0-.461 0z" />
            </svg>
        );
    };

    const StarHalfIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="#ffa400"
                className="bi bi-star"
                viewBox="0 0 20 20"
            >
                <path d="M5.354 5.119 7.538.792A.52.52 0 0 
                    1 8 .5c.183 0 .366.097.465.292l2.184 
                    4.327 4.898.696A.54.54 0 0 1 16 6.32a.55.55 
                    0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 
                    13.187l-4.389 2.256a.5.5 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 
                    6.765a.55.55 0 0 1-.172-.403.6.6 0 0 1 
                    .085-.302.51.51 0 0 1 .37-.245zM8 12.027a.5.5 0 
                    0 1 .232.056l3.686 1.894-.694-3.957a.56.56 0 
                    0 1 .162-.505l2.907-2.77-4.052-.576a.53.53 0 
                    0 1-.393-.288L8.001 2.223 8 2.226z" />
            </svg>
        );
    };

    return (
        <div className={styles.container}>
            <div className="left-col">
                <div className={styles.flexRow}>
                    <div className="flex-shrink-0 sm:w-40 sm:h-40 w-28 h-28 border-2 border-white border-2 shadow-md">
                        <img
                            src={listing.thumbnail && listing.thumbnail.includes('.amazonaws.com')
                                ? listing.thumbnail
                                : charmhealthlogo_placeholder}
                            alt="Logo"
                            className={"w-full h-full" + (listing.thumbnail && listing.thumbnail.includes('.amazonaws.com') ? '' : 'border-2 border-lightNeutral')}
                        />
                    </div>

                    <div className={styles.textContainer}>
                        <div className={styles.listingName}>{listing.name}</div>
                        <div>
                            {listing.rating > 0 ? (
                                <div className={styles.ratingContainer}>
                                    {[...Array(5)].map((_, i) => {
                                        const starPosition = i + 1;
                                        const fullStars = Math.floor(listing.rating);
                                        const hasHalfStar = listing.rating - fullStars >= 0.5;

                                        if (starPosition <= fullStars) {
                                            return <StarFilledIcon key={i} />;
                                        } else if (starPosition === fullStars + 1 && hasHalfStar) {
                                            return <StarHalfIcon key={i} />;
                                        } else {
                                            return <StarEmptyIcon key={i} />;
                                        }
                                    })}
                                    {/* <span className={styles.ratingText}>
                                    {listing.rating} ({listing.totalRatings})
                                    </span> */}
                                </div>
                            ) : (
                                <div className={styles.ratingContainer}>
                                    {[...Array(5)].map((_, i) => (
                                        <StarEmptyIcon key={i} />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="sm:mt-1">
                <div className="flex flex-row overflow-x-auto space-x-2 mt-3 scrollbar-hide">
                    {listing?.categories?.map((category, index) => (
                        <div
                            key={index}
                            className="w-fit rounded-full px-3 py-1 text-sm whitespace-nowrap flex-shrink-0"
                            style={{ backgroundColor: getCategoryColor(category.id) }}
                        >
                            {getCategoryLabel(category.id)}
                        </div>
                    ))}
                </div>
            </div>


            <p className="mt-3 h-[368px] hidden sm:block text-left text-[18px] overflow-y-auto font-proximanova scrollbar-thin scrollbar-thumb-gray-300 mb-0">
                {listing?.description}
            </p>

            <div className="flex justify-between items-center">
                <div className='w-fit flex items-center'>
                    {listing.is_published === true && (
                        <div className={styles.statusPublished}>
                            <div className={styles.statusIconPublished}></div>
                            <div className={styles.statusText}>Published</div>
                            <a
                                href={`https://www.charmhealthhub.com/explore/${listing.id}`}
                                target="_blank"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(`https://www.charmhealthhub.com/explore/${listing.id}`);
                                    showToast('Link copied to clipboard', `https://www.charmhealthhub.com/explore/${listing.id}`, 'success');
                                }}
                                className='text-charmHover'
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                                </svg>
                            </a>
                            <a href={`https://www.charmhealthhub.com/explore/${listing.id}`} target='_blank' className='text-charmHover'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                    <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                </svg>
                            </a>
                        </div>
                    )}
                    {listing.is_published === false && (
                        <div className={styles.statusNotPublished}>
                            <div className={styles.statusIconNotPublished}></div>
                            <div className={styles.statusText}>Not Published</div>
                        </div>
                    )}
                    {listing.is_published && (
                        <div className="relative inline-block text-left">

                            {/* Dropdown Trigger Button */}
                            <button
                                onClick={toggleDropdown}
                                // className=" border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50"
                                aria-haspopup="true"
                                aria-expanded={dropdownOpen}
                            >
                                <svg className="ml-0 h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fillRule="evenodd"
                                        d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 
                                                1 0 111.414 1.414l-4 4a1 1 
                                                0 01-1.414 0l-4-4a1 1 
                                                0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </button>

                            {/* Dropdown Menu */}
                            {dropdownOpen && (
                                <div
                                    className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="options-menu"
                                >
                                    <button
                                        onClick={() => {
                                            handleUnpublishClick(listing);
                                            setDropdownOpen(false);
                                        }}
                                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        role="menuitem"
                                    >
                                        Unpublish
                                    </button>
                                </div>
                            )}

                        </div>
                    )}
                </div>
                <div className="w-fit">
                    <button
                        onClick={() => handleEditClick(listing)}
                        className={styles.updateButton}
                    >
                        Update Listing
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ListingIcon;
